import React from 'react';
import {atom} from 'jotai';
import {IDomainValue} from '../models/IDomainValue';

export const domainValueAtom = atom<Map<String, IDomainValue[]>>(new Map());
export const universityCountAtom = atom<Map<String, number>>(new Map());
